import React, { Component } from 'react';
import Util from '../../Util';
import Grid from '../../componentes/Grid';

class AndamentoProtocolo extends Component {
  exibeNomeCampo(unidadeAdministrativa) {
    if (unidadeAdministrativa && typeof (unidadeAdministrativa.nome) !== 'undefined') {
      return unidadeAdministrativa.nome;
    }
    return '';
  }

  renderPaginationShowsTotal(start, to, total) {
    return (
      <p>Exibindo resultados de <b>{start}</b> até <b>{to}</b>, total de <b>{total}</b> registros</p>
    );
  }

  render() {
    const columns = [
      { name: 'data', label: 'Data', width: '90px', dataFormat: Util.formataData, headerAlign: 'center', dataAlign: 'center' }
      , { name: 'dataRecebimento', label: 'Recebimento', width: '130px', dataFormat: Util.formataData, headerAlign: 'center', dataAlign: 'center' }
      , { name: 'origem', label: 'Origem', width: '200px', dataFormat: this.exibeNomeCampo }
      , { name: 'destino', label: 'Destino', width: '200px', dataFormat: this.exibeNomeCampo }
      , { name: 'situacaoProtocolo', label: 'Situação', width: '120px', dataFormat: this.exibeNomeCampo }
    ];

    return (
      <Grid data={this.props.andamentos} keyField={'id'} columns={columns} />
    );
  }
}

export default AndamentoProtocolo;


// WEBPACK FOOTER //
// ./src/modulos/protocolo/consultar/AndamentoProtocolo.js